import clsx from 'clsx'
import { Film } from 'lucide-react'

import { inferMediaKind, resolveMediaDisplayUrl } from '@/features/studio/lib/media-display'

export function MediaKindThumb({
  url,
  mediaKind,
  className,
  videoClassName,
  imageClassName,
  emptyClassName,
}: {
  url?: string | null
  mediaKind?: string | null
  className?: string
  videoClassName?: string
  imageClassName?: string
  emptyClassName?: string
}) {
  const resolved = resolveMediaDisplayUrl(url)
  const kind = inferMediaKind(mediaKind, url)

  if (!resolved) {
    return (
      <div className={clsx('flex h-full w-full items-center justify-center bg-[#0a0a10]', emptyClassName, className)}>
        <Film className="h-4 w-4 text-zinc-600" />
      </div>
    )
  }

  if (kind === 'video') {
    return (
      <video
        src={resolved}
        muted
        playsInline
        preload="metadata"
        className={clsx('h-full w-full object-cover', videoClassName, className)}
      />
    )
  }

  if (kind === 'audio') {
    return (
      <div className={clsx('flex h-full w-full items-center justify-center bg-[#0a0a10] text-xs text-zinc-400', className)}>
        ♪
      </div>
    )
  }

  return <img src={resolved} alt="" className={clsx('h-full w-full object-cover', imageClassName, className)} />
}
